import { render, staticRenderFns } from "./CourseContent.vue?vue&type=template&id=ec997528&scoped=true"
import script from "./CourseContent.vue?vue&type=script&lang=js"
export * from "./CourseContent.vue?vue&type=script&lang=js"
import style0 from "./CourseContent.vue?vue&type=style&index=0&id=ec997528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec997528",
  null
  
)

export default component.exports